import React from "react";
import { connect } from "react-redux";
import Dashboard from "powerbi-report-component";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";
const config = {};

class PreNominasGrafico extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  render() {
    const reporte = [];
    if (this.props.companyId) {

      config.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSection65f0c9fe7c16ea421a63&$filter=Tabla_x0020_Ruts_x0020_Empresa/Rut eq '${this.props.companyId.replace('-','')}'`;

      config.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };

      const key = `prenominas${new Date().getTime()}`;
      reporte.push(<Dashboard
        key={key}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config.embedUrl}
        embedId={this.props.config.embedId}
        extraSettings={{
          filterPaneEnabled: config.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config.extraSettings.navContentPaneEnabled,
        }}
        permissions="All"
        style={{
          height: "50%",
          border: "0",
          padding: "0px",
          background: "#eee",
        }}
      />);
    }


    return (
      <React.Fragment>
        <div className='header-subTitle' style={{ marginBottom: 5, marginTop: 0 }}>Estado actual de los trabajadores enviados por la empresa en una pre-nóminas de contacto estrecho asociada al virus COVID-19.</div>
        {reporte}
        <div className='covid-footer'>
          <div className='header-subTitle'><b>Glosario</b></div>
          <ul className='itemlist'>
            <li className='itemlist'><div className='header-subTitle'><b>Con Contacto Estrecho: </b><span>trabajadores que al ser consultados refieren haber tenido contacto con un enfermo o sospechoso COVID-19</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>Sin Contacto Estrecho: </b><span>trabajadores que al ser consultados refieren no haber tenido contacto con un enfermo o sospechoso COVID-19</span></div></li>
            <li className='itemlist'><div className='header-subTitle'><b>No Contactable: </b><span>trabajadores a los que no ha sido posible contactar para evaluar su exposición</span></div></li>
          </ul>
        </div>
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({
  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  //sucursalId: state.global.sucursalId,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PreNominasGrafico);

